module.exports = __webpack_public_path__ + "img/素材.e061bcea.png";